import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from 'vuex-persistedstate';
import menuItems from "./modules/menus.js"
Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		cachedStateName: '', // 存放 StateName
		scrollPosition: 0, // 存放滚动位置
	},
	mutations: {
		SET_STATE_NAME(state, newName) {
			state.cachedStateName = newName;
		},
		setScrollPosition(state, position) {
			state.scrollPosition = position;
		},
	},
	modules:{
		menuItems
	},
	plugins: [createPersistedState()], 
})
